export default __webpack_public_path__ + "static/media/matchPlay_DefaultUserIcon.a6143582.png";